<template>
  <section class="wrapper_type_2">
    <b-navbar
      class="horizontal_nav_bar"
      :class="collapseNavbar ? 'opened' : ''"
    >
      <b-navbar-brand href="#" class="hamburger_container">
        <span class="hamburger_span_div" @click="toggleCollapsibleNavBar">
          <div class="span-toggler-bar bar1"></div>
          <div class="span-toggler-bar bar2"></div>
          <div class="span-toggler-bar bar3"></div>
        </span>
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-50 d-lg-none mb-md-3 mb-sm-5 mb-lg-0"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
          @change="changeLanguage"
          class="w-50 d-lg-none mb-3 mb-md-3 mb-lg-0 mr-3"
        >
          <option disabled value="">
            {{ $t("text.cMasterLayout.selectLanguage") }}
          </option>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select> -->
      </b-navbar-brand>

      <div style="margin: 0 auto; width: 100%" class="m-hide"></div>

      <b-collapse id="nav-collapse" is-nav>
        <!-- SELECT LANGUAGE -->
        <select
          @change="changeLanguage"
          v-model="usedLang"
          class="w-100 mb-3 mb-md-3 mb-lg-0 mr-3 d-none d-lg-block"
          style="width: 100px !important"
        >
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select>
        <!-- <select
          @change="changeLanguage"
          class="w-100 mb-3 mb-md-3 mb-lg-0 mr-3 d-none d-lg-block"
          style="width: 200px !important"
        >
          <option disabled value="">
            {{ $t("text.cMasterLayout.selectLanguage") }}
          </option>
          <option value="fr">FR</option>
          <option value="en">EN</option>
        </select> -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown>
            <template v-slot:button-content>
              <b class="user_profile_span"
                ><span>{{ userName }}</span> &#x25bc;</b
              >
            </template>
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'customer_profile' }">{{
                $t("text.cusMasterLayout.profile")
              }}</router-link></b-dropdown-item
            >
            <b-dropdown-item href="#"
              ><router-link :to="{ name: 'sub_accounts' }">{{
                $t("text.cusMasterLayout.subAccounts")
              }}</router-link></b-dropdown-item
            >
            <b-dropdown-item href="#" @click="signOutUser">{{
              $t("text.cusMasterLayout.signOut")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="masterLayoutWrapper" :class="collapseNavbar ? 'opened' : ''">
      <section class="main_content">
        <transition name="moveInUp" mode="out-in" appear>
          <div class="slot_div inner_main_content" ref="inner_main_content">
            <slot>
              <router-view />
            </slot>
          </div>
        </transition>
      </section>
    </div>

    <section
      id="mlDiv"
      :style="[
        windowLoc == 'interswitchenergy'
          ? { backgroundColor: '#11386a' }
          : windowLoc == 'rainoil'
          ? { backgroundColor: '#0a0044' }
          : windowLoc == 'eterna'
          ? { backgroundColor: '#007236' }
          : windowLoc == 'bovas'
          ? { backgroundColor: '#b28b00' }
          : null,
      ]"
      class="sidebar use-tiny-scroll"
      :class="collapseNavbar ? 'collapsed' : ''"
      @mouseover="toggleSidenavText"
      @mouseleave="hideTitles"
    >
      <div class="text-center">
        <div class="company-logo-wrapper">
          <img
            src="@/assets/img/ep-logo.svg"
            class="lg m-hide-icon company-logo"
            width="153"
          />
        </div>
        <div class="mobile-user-details">
          <div class="mt-3 text-right logo_section">
            <img
              src="@/assets/img/close_btn.png"
              width="35px"
              height="35px"
              @click="toggleCollapsibleNavBar"
            />
          </div>
          <div class="mt-3 text-center dasboard_type_button_section">
            <div class="mobile_epump_logo">
              <img src="@/assets/img/mobieli_white_epump_logo.svg" width="20" />
            </div>
            <h6 class="mt-2 text-white">{{ userName }}</h6>
            <small class="mt-2 text-white">{{ userDetails.email }}</small>
          </div>
        </div>
      </div>
      <div class="mt-3 dasboard_type_button_section"></div>

      <div class="mt-4 mb-4 menu-wrapper">
        <ul class="list-group" style="">
          <li
            class="list-group-item"
            :class="activeRoute === 'userDashboard' ? 'navbar_item_active' : ''"
          >
            <router-link
              :to="{ name: 'userDashboard' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img alt="" src="@/assets/img/dashboard (1).png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.dashboard") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="activeRoute === 'fuelbalance' ? 'navbar_item_active' : ''"
          >
            <router-link :to="{ name: 'fuelbalance' }" class="vue_router_link">
              <span class="mr-2"
                ><img src="@/assets/img/money(1).png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.fuelBalance") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="activeRoute === 'voucher' ? 'navbar_item_active' : ''"
          >
            <router-link :to="{ name: 'voucher' }" class="vue_router_link">
              <span class="mr-2"
                ><img src="@/assets/img/voucher.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.vouchers") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item treeview"
            :class="
              activeRoute === 'vehicle' || activeRoute === 'vehicle'
                ? 'navbar_item_active open'
                : ''
            "
          >
            <a href="#">
              <span class="mr-3"
                ><img src="@/assets/img/car(2).png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.vehicles") }}
              </span>
              <i class="fa fa-angle-right upArrow"></i>
            </a>
            <ul class="treeview-menu">
              <li
                class="list-group-item"
                :class="activeRoute === 'vehicle' ? 'navbar_item_active' : ''"
              >
                <router-link :to="{ name: 'vehicle' }" class="vue_router_link">
                  <span class="sidenav_list_title">
                    {{ $t("text.cusMasterLayout.allVehicles") }}
                  </span>
                </router-link>
              </li>
              <li
                class="list-group-item"
                :class="
                  activeRoute === 'linked-vehicle' ? 'navbar_item_active' : ''
                "
              >
                <router-link
                  :to="{ name: 'linked-vehicle' }"
                  class="vue_router_link"
                >
                  <span class="sidenav_list_title">
                    {{ $t("text.cusMasterLayout.generatedVoucher") }}
                  </span>
                </router-link>
              </li>
            </ul>
          </li>
          <li
            class="list-group-item"
            :class="activeRoute === 'drivers' ? 'navbar_item_active' : ''"
          >
            <router-link :to="{ name: 'drivers' }" class="vue_router_link">
              <span class="mr-2"
                ><img src="@/assets/img/chauffer.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.drivers") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="activeRoute === 'cards' ? 'navbar_item_active' : ''"
          >
            <router-link :to="{ name: 'cards' }" class="vue_router_link">
              <i
                class="mr-2 text-white fa fa-credit-card"
                style="font-size: 20px"
                aria-hidden="true"
              ></i>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.remisCards") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="
              activeRoute === 'fuel_consumption' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{ name: 'fuel_consumption' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/car.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.consumption") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="activeRoute === 'retainership' ? 'navbar_item_active' : ''"
          >
            <router-link :to="{ name: 'retainership' }" class="vue_router_link">
              <span class="mr-2"
                ><img src="@/assets/img/debt.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.retainership") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="
              activeRoute === 'outstanding_payments' ? 'navbar_item_active' : ''
            "
            v-if="role"
          >
            <router-link
              :to="{ name: 'outstanding_payments' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/debt.svg" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.payments") }}
              </span>
            </router-link>
          </li>
          <li
            class="list-group-item"
            :class="
              activeRoute === 'extended_report' ? 'navbar_item_active' : ''
            "
          >
            <router-link
              :to="{ name: 'extended_report' }"
              class="vue_router_link"
            >
              <span class="mr-2"
                ><img src="@/assets/img/fast.png" width="20px"
              /></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.extendedReport") }}
              </span>
            </router-link>
          </li>
          <!-- partnership logo -->
          <div
            v-if="windowLoc !== 'localhost' && windowLoc !== 'efueling'"
            class="partner_wraper_side_nav mt-2 mb-4"
          >
            <div class="text-center partners_div mt-2 mb-4">
              <div>
                <img
                  src="@/assets/img/fuelmetrics (5).png"
                  class="mr-3"
                  width="100px"
                />
              </div>
              <div class="vl white"></div>
              <div>
                <img
                  :src="[
                    windowLoc == 'interswitchenergy'
                      ? require('@/assets/img/ISW- Logo white.png')
                      : windowLoc == 'rainoil'
                      ? require('@/assets/img/rainoil_1a.jpg')
                      : windowLoc == 'eterna'
                      ? require('@/assets/img/Eterna-logo_1a.jpg')
                      : windowLoc == 'bovas'
                      ? require('@/assets/img/bovas_1a.png')
                      : 'https://epump.com.ng/images/logo2.svg',
                  ]"
                  class="ml-3"
                  width="100px"
                  height="40px"
                />
              </div>
            </div>
          </div>
          <li
            class="list-group-item m-view vue_router_link"
            @click="signOutUser"
          >
            <a href="" class="vue_router_link">
              <span class="mr-2"
                ><i
                  class="mr-3 fa fa-sign-out"
                  style="font-size: 20px; color: white"
                ></i
              ></span>
              <span class="sidenav_list_title">
                {{ $t("text.cusMasterLayout.logout") }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </section>
  </section>
</template>

<script>
import LogoUrl from "@/assets/img/logo.svg";
import masterbackgroundUrl from "@/assets/img/retain.jpg";
import countryProducts from "@/products";

export default {
  name: "MasterLayout",
  data() {
    return {
      role: false,
      LogoUrl,
      masterbackgroundUrl,
      collapseNavbar: true,
      activeRoute: null,
      mobileNav: this.$store.getters.getMobileNavDrawer,
      //   userDetails: localStorage.getItem("userDetails")
      //     ? JSON.parse(localStorage.getItem("userDetails"))
      //     : null,
      windowLoc: window.location.hostname.split(".")[0],
      usedLang: this.$store.getters.getLanguage,
    };
  },
  watch: {
    collapseNavbar(value) {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      if (value) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
  },
  computed: {
    userDetails() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    userName: {
      get() {
        if (localStorage.getItem("userDetails")) {
          return this.userDetails.firstName + "  " + this.userDetails.lastName;
        } else {
          return "Username";
        }
      },
      set(value) {},
    },
  },
  created() {
    if (!localStorage.getItem("userDetails")) {
      this.$router.push({ name: "login" });
    }
    const role = JSON.parse(localStorage.getItem("userDetails")).role;
    this.role = role.includes("Account Manager");
  },
  mounted() {
    const contLang = this.$root.$i18n.locale.split("-")[0];
    this.$store.commit("setLanguage", contLang);
    this.usedLang = this.$store.getters.getLanguage;

    $(".treeview > a").on("click", function (e) {
      e.preventDefault();
      var me = $(this);

      if (me.parent("li").hasClass("open")) {
        //close me
        me.parent("li").removeClass("open");
      } else {
        // Open me & close others
        $(".treeview").removeClass("open");
        me.parent("li").addClass("open");
      }
    });
  },
  beforeMount() {
    this.activeRoute = this.$route.name;
  },
  methods: {
    changeCountry(e) {
      this.$store.commit("setCountry", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);

      localStorage.setItem(
        "countryProducts",
        JSON.stringify(countryProducts[e.target.value])
      );
      this.$store.commit("setCountryProducts", countryProducts[e.target.value]);
    },
    changeLanguage(e) {
      this.$store.commit("setLanguage", e.target.value);
      const locale = `${this.$store.getters.getLanguage}-${this.$store.getters.getCountry}`;
      this.$root.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$eventHub.$emit("remountCom");
    },
    toggleCollapsibleNavBar() {
      this.collapseNavbar = !this.collapseNavbar;
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (!this.collapseNavbar) {
        const allListTitles = Array.from(
          document.querySelectorAll(".sidenav_list_title")
        );
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("list_open")) {
            el.classList.remove("list_open");
            el.classList.add("open");
          }
        });
      } else {
        if (
          document.querySelector(".sidebar").classList.contains("collapsed")
        ) {
          allListTitles.forEach((el) => {
            el.style.display = "none";
          });
        }

        treeviews.forEach((el) => {
          if (Array.from(el.classList).includes("open")) {
            el.classList.add("list_open");
            el.classList.remove("open");
          }
        });
      }
    },
    toggleSidenavText() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );
      const treeviews = Array.from(document.querySelectorAll(".treeview"));

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "inline";
        });
        treeviews.forEach((el) => {
          const classList = Array.from(el.classList);
          if (classList.includes("open")) {
            el.classList.add("open");
            el.classList.remove("list_open");
          }
        });
      }
    },
    hideTitles() {
      const allListTitles = Array.from(
        document.querySelectorAll(".sidenav_list_title")
      );

      Array.from(document.querySelectorAll("li")).forEach((li) => {
        li.classList.remove("open");
      });

      if (this.collapseNavbar) {
        allListTitles.forEach((el) => {
          el.style.display = "none";
        });
      }
    },
    signOutUser() {
      const answer = window.confirm(
        this.$t("text.cusMasterLayout.confirmLogout")
      );
      if (answer) {
        if (localStorage.getItem("locale")) {
          const locale = localStorage.getItem("locale");
          this.$store.commit("setBaseLocale", locale);
        }

        this.$store.dispatch("logout");
      }
    },
    changeRoute(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>
